import React from 'react';

const ActivityContext = React.createContext();
const AppContext = React.createContext();
const EditContext = React.createContext();
const EventContext = React.createContext();
const FieldsContext = React.createContext();
const FormContext = React.createContext();
const ParticipantsContext = React.createContext();
const SubactivityContext = React.createContext();

export {
  ActivityContext,
  AppContext,
  EditContext,
  EventContext,
  FieldsContext,
  FormContext,
  ParticipantsContext,
  SubactivityContext
};
